import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import { withStyles, useMediaQuery } from '@material-ui/core';
import { Dialog, Button, Icon, P, Span } from 'components/Ui';

import MUIStyles from '../BrandSwitchDialog/styles';
import styles from '../BrandSwitchDialog/styles.scss';

const ClearCartDialog = ({ handleClearCartShop, isCartClear }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Dialog
      size="small"
      open={isCartClear}
      isCloseIcon
      fullScreen={isMobile}
      onClose={handleClearCartShop}
      disableBackdropClick
      disableKeyboard
    >
      <div className={styles.container}>
        <Icon icon="shopping-cart" />
        <Span className={styles.title}>Whoops!</Span>
        <div className={styles.text}>
          <P>
            Based on the delivery address you entered, product availability may
            have changed. Please go back and add products again so we can ensure
            all the refreshment is available in your area.
          </P>
        </div>
        <div className={styles.buttonsContainer}>
          <Button
            className={styles.btn}
            text="Shop To"
            onClick={handleClearCartShop}
          />
        </div>
      </div>
    </Dialog>
  );
};

export default withStyles(MUIStyles, { withTheme: true })(ClearCartDialog);
